var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.691,
    height: 26.667,
    viewBox: "0 0 55.691 55.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#006ba6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M54.607,71.867H21.06A11.064,11.064,0,0,1,10,60.807V27.26A11.064,11.064,0,0,1,21.06,16.2H54.631a11.064,11.064,0,0,1,11.06,11.06V60.831A11.08,11.08,0,0,1,54.607,71.867Z",
    transform: "translate(-10 -16.2)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M80.572,34.487l7.194,14.07h3.842L80.572,27l-13.9,27.16h3.817Zm7.952,19.918L80.6,69.894,74.528,58.027H66.6v3.426h5.824L80.6,77.406,90.628,57.831h17.789V54.405Z",
    transform: "translate(-52.751 -24.357)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5229108d16af9378e085fef3439fa566.svg";
export { ForwardRef as ReactComponent };